// @flow
import * as React from 'react';
import { Box } from 'grommet';
import type { Action } from 'esm-web-pro/components/layout/sidePanel/Actions';
import Actions from 'esm-web-pro/components/layout/sidePanel/Actions';

type Props = {
    actions: Action[],
};

const MainActions = (props: Props) => (
    <Box>
        <Actions {...props} />
    </Box>
);

export default MainActions;
